import { render, staticRenderFns } from "./parentsInformation2.vue?vue&type=template&id=172d8b96&scoped=true&"
import script from "./parentsInformation2.vue?vue&type=script&lang=js&"
export * from "./parentsInformation2.vue?vue&type=script&lang=js&"
import style0 from "./parentsInformation2.vue?vue&type=style&index=0&id=172d8b96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172d8b96",
  null
  
)

export default component.exports